<template>
  <form-group
    :errors="internalErrors"
    :label="label"
    @focus="focus"
    class="color-code-input uk-display-inline"
  >
    <div class="uk-inline">
      <span class="uk-form-icon">
        <color-preview
          :code="internalValue"
          @click.native="$refs.dropdown.toggle()"
          class="color-code-input__preview"
        />
      </span>

      <input
        :class="inputCss"
        :disabled="disabled"
        :placeholder="placeholder"
        :value="internalValue"
        @input="onInput"
        class="uk-input"
        ref="primaryInput"
        type="text"
      />
    </div>

    <div class="uk-inline">
      <dropdown-button ref="dropdown">
        <icon name="paint-bucket" slot="button" />
        <color-picker
          class="color-code-input__picker uk-margin-top"
          v-model="pickerData"
        />
        <common-button
          @click="submit"
          class="color-code-input__button uk-margin-top"
          icon="check"
        >{{$t('actions.apply')}}</common-button>
      </dropdown-button>
    </div>
  </form-group>
</template>

<script>
import { Chrome as ColorPicker } from 'vue-color';
import ColorPreview from '@/components/ColorPreview';
import CommonButton from '@/components/CommonButton';
import DropdownButton from '@/components/DropdownButton';
import Input from '@/mixins/Input';

export default {
  name: 'color-code-input',
  mixins: [Input],
  components: {
    ColorPicker,
    ColorPreview,
    CommonButton,
    DropdownButton,
  },
  props: {
    value: String,
    placeholder: String,
  },
  data() {
    return {
      pickerData: { hex: this.value },
    };
  },
  methods: {
    submit() {
      const value = this.pickerData.hex;
      this.internalValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
      this.clearErrors();
      this.$refs.dropdown.hide();
    },
  },
};
</script>

<style lang="scss">
.color-code-input__button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ColorCodeInput.vue?16140494